"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeFeatures_de_de = void 0;
function backofficeFeatures_de_de() {
    return {
        "backoffice.features.checkin.configuration.apps": "Check-In Apps",
        "backoffice.features.workflow.configuration.amount": "Workflows",
        "backoffice.features.devices.configuration.amount": "Registrierbare Check-In Geräte",
        "backoffice.features.forms.configuration.amount": "Formulare",
        "backoffice.features.files.configuration.space": "Speicherplatz für Dateien",
        "backoffice.features.files.configuration.space_suffix": "GB",
        "backoffice.features.email.configuration.type": "E-Mail Dienst",
        "backoffice.features.email.configuration.type_values.custom": "Anpassbar",
        "backoffice.features.email.configuration.type_values.standard": "Vereinfacht",
        "backoffice.features.i18n.configuration.locales": "Anzahl der Sprachen",
        "backoffice.features.custom.configuration.datastorage": "Benutzerdefinierte Datensätze",
        "backoffice.features.custom.configuration.datatypes": "Benutzerdefinierte Datentypen",
        "backoffice.features.users.configuration.amount": "Kunden",
        "backoffice.features.products.configuration.amount": "Produkte",
        "backoffice.features.custombackoffices.configuration.amount": "Konfigurierbare Oberflächen",
        "backoffice.features.cms.configuration.amount": "Cms",
        "backoffice.features.cms.configuration.pages": "CMS Seiten",
        "backoffice.features.configuration.configuration.amount": "Konfiguration",
        "backoffice.features.configuration.configuration.enabled": "Konfiguration",
        "backoffice.features.optin.configuration.amount": "Optin",
        "backoffice.features.optin.configuration.enabled": "Optin",
        "backoffice.features.impex.configuration.amount": "Impex",
        "backoffice.features.impex.configuration.enabled": "Impex",
        "backoffice.features.internationalization.configuration.amount": "Internationalisierung",
        "backoffice.features.internationalization.configuration.locales": "Sprachumgebungen"
    };
}
exports.backofficeFeatures_de_de = backofficeFeatures_de_de;
